// SyntheticOGSFace: the splat face posed by its OWN facial joints (ORL) — no rig2mesh.
// Notes: ~/comments/aos-threejs-poc/syntheticOgsFace_scope.md

import { createOrlRig } from '../../lib/orl/orlRig.js'
import { MH_RIG_NAMES } from './rigNamesMh.js'
import { arkitToMh, MH_LEN } from './arkitToMh.js'
import { captureFaceJointRig, applyJointDeltas } from './faceJointDrive.js'

export const SYNTHETIC_FACE_PACK = 'orl_pack.bin'
export const SYNTHETIC_FACE_DEV_PACK_URL = '/assets/facetest/orl_pack.bin'

/** The scene.json declaration with its URL override: ?syntheticface=1 forces on, 0 forces off. */
export function syntheticFaceEnabled(declared, search = window.location.search) {
  const value = new URLSearchParams(search).get('syntheticface')
  if (value === '1') return true
  if (value === '0') return false
  return declared === true
}

/** Per-frame core: ARKit-52 -> ORL joint deltas -> posed facial bones. Change-gated. */
export function createSyntheticFacePusher({ evaluateRig, faceRig, onPosed }) {
  const mh = new Float32Array(MH_LEN)
  const lastFrame = new Float32Array(52)
  let hasFrame = false
  return {
    setArkit(arkit) {
      if (hasFrame && sameFrame(lastFrame, arkit)) return false
      lastFrame.set(arkit)
      hasFrame = true
      arkitToMh(arkit, mh)
      applyJointDeltas(faceRig, evaluateRig(mh).jointOut)
      onPosed?.()
      return true
    },
  }
}

function sameFrame(a, b) {
  for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) return false
  return true
}

/** Assemble the drive over a part rig's scene. Null (reason logged) when a gate fails. */
export async function createSyntheticOgsFace({ packBytes, sceneRoot, onPosed, log = (m) => console.info(m) }) {
  const rig = await createOrlRig({
    getBytes: () => packBytes,
    controlNames: MH_RIG_NAMES,
    log,
  })
  const faceRig = captureFaceJointRig(sceneRoot, rig.manifest.jointNames)
  if (!faceRig) {
    rig.release()
    console.error('[synthetic-face] no pack joint names matched the part rig — staying off')
    return null
  }
  const pusher = createSyntheticFacePusher({ evaluateRig: (vector) => rig.evaluateRig(vector), faceRig, onPosed })
  log(`[synthetic-face] armed — ${faceRig.matched}/${rig.manifest.jointNames.length} facial joints bound`)
  return { setArkit: pusher.setArkit, matched: faceRig.matched, release: () => rig.release() }
}
